// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Manrope-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --eaim-purple:#6C2BD9;
  --eaim-pink:#E34AB5;
  --magenta:#B31E8D;
  --border:#DADDE1;
  --text:#27323A;
  --white:#fff;
}

@font-face {
  font-family: "Manrope-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

*{box-sizing:border-box}
body { margin:0; font-family: "Manrope-Regular", sans-serif; color:var(--text); }

.eaim-wrap { min-height:100dvh; background:#f7f7fa; }

/* Header */
.eaim-header{
  background: linear-gradient(135deg, var(--eaim-purple) 0%, var(--eaim-pink) 100%);
  color:var(--white);
  padding:18px 24px 22px;
  border-bottom:1px solid rgba(0,0,0,.12);
}
.brand { display:flex; flex-direction:column; align-items:flex-start; }
.brand-eaim{
  font-weight:900; letter-spacing:.06em;
  font-size:42px; line-height:1; text-shadow:0 2px 8px rgba(0,0,0,.15);
}
.brand-sub{ opacity:.9; margin-top:4px; font-size:12px }

/* Content */
.container{ max-width:680px; margin:0 auto; padding:18px 16px; font-family: "Manrope-Regular", sans-serif; }

.title{
  margin:0 0 12px;
  font-size:20px;
  font-weight:700;
}

.form{ display:flex; flex-direction:column; align-items:center; gap:14px; }

.input{
  width:100%;
  height:44px;
  border-radius:8px;
  border:1px solid var(--border);
  padding:0 14px;
  font-size:16px;
  outline:none;
  transition: box-shadow .15s ease, border-color .15s ease;
}
.input:focus{
  border-color:#c15aba;
  box-shadow:0 0 0 3px rgba(227,74,181,.18);
}

/* Button */
.btn{
  border:none;
  border-radius:10px;
  padding:10px 28px;
  font-size:16px;
  font-weight:600;
  color:#fff;
  background:var(--magenta);
  cursor:pointer;
  transition: transform .04s ease, filter .15s ease;
  font-family: " Manrope-Regular", sans-serif;
}
.btn:hover{ filter:brightness(1.05) }
.btn:active{ transform: translateY(1px) }

/* Small screens */
@media (min-width: 520px){
  .card{ padding:24px 22px }
}
`, "",{"version":3,"sources":["webpack://./src/Components/search.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,+DAA2D;EAC3D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,EAAE,qBAAqB;AACvB,OAAO,QAAQ,EAAE,0CAA0C,EAAE,iBAAiB,EAAE;;AAEhF,aAAa,iBAAiB,EAAE,kBAAkB,EAAE;;AAEpD,WAAW;AACX;EACE,iFAAiF;EACjF,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;AACzC;AACA,SAAS,YAAY,EAAE,qBAAqB,EAAE,sBAAsB,EAAE;AACtE;EACE,eAAe,EAAE,oBAAoB;EACrC,cAAc,EAAE,aAAa,EAAE,qCAAqC;AACtE;AACA,YAAY,UAAU,EAAE,cAAc,EAAE,eAAe;;AAEvD,YAAY;AACZ,YAAY,eAAe,EAAE,aAAa,EAAE,iBAAiB,EAAE,0CAA0C,EAAE;;AAE3G;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,OAAO,YAAY,EAAE,qBAAqB,EAAE,kBAAkB,EAAE,QAAQ,EAAE;;AAE1E;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;EACd,cAAc;EACd,YAAY;EACZ,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA,WAAW;AACX;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EACjD,2CAA2C;AAC7C;AACA,YAAY,wBAAwB;AACpC,aAAa,2BAA2B;;AAExC,kBAAkB;AAClB;EACE,OAAO,kBAAkB;AAC3B","sourcesContent":[":root{\n  --eaim-purple:#6C2BD9;\n  --eaim-pink:#E34AB5;\n  --magenta:#B31E8D;\n  --border:#DADDE1;\n  --text:#27323A;\n  --white:#fff;\n}\n\n@font-face {\n  font-family: \"Manrope-Regular\";\n  src: url(\"../fonts/Manrope-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n*{box-sizing:border-box}\nbody { margin:0; font-family: \"Manrope-Regular\", sans-serif; color:var(--text); }\n\n.eaim-wrap { min-height:100dvh; background:#f7f7fa; }\n\n/* Header */\n.eaim-header{\n  background: linear-gradient(135deg, var(--eaim-purple) 0%, var(--eaim-pink) 100%);\n  color:var(--white);\n  padding:18px 24px 22px;\n  border-bottom:1px solid rgba(0,0,0,.12);\n}\n.brand { display:flex; flex-direction:column; align-items:flex-start; }\n.brand-eaim{\n  font-weight:900; letter-spacing:.06em;\n  font-size:42px; line-height:1; text-shadow:0 2px 8px rgba(0,0,0,.15);\n}\n.brand-sub{ opacity:.9; margin-top:4px; font-size:12px }\n\n/* Content */\n.container{ max-width:680px; margin:0 auto; padding:18px 16px; font-family: \"Manrope-Regular\", sans-serif; }\n\n.title{\n  margin:0 0 12px;\n  font-size:20px;\n  font-weight:700;\n}\n\n.form{ display:flex; flex-direction:column; align-items:center; gap:14px; }\n\n.input{\n  width:100%;\n  height:44px;\n  border-radius:8px;\n  border:1px solid var(--border);\n  padding:0 14px;\n  font-size:16px;\n  outline:none;\n  transition: box-shadow .15s ease, border-color .15s ease;\n}\n.input:focus{\n  border-color:#c15aba;\n  box-shadow:0 0 0 3px rgba(227,74,181,.18);\n}\n\n/* Button */\n.btn{\n  border:none;\n  border-radius:10px;\n  padding:10px 28px;\n  font-size:16px;\n  font-weight:600;\n  color:#fff;\n  background:var(--magenta);\n  cursor:pointer;\n  transition: transform .04s ease, filter .15s ease;\n  font-family: \" Manrope-Regular\", sans-serif;\n}\n.btn:hover{ filter:brightness(1.05) }\n.btn:active{ transform: translateY(1px) }\n\n/* Small screens */\n@media (min-width: 520px){\n  .card{ padding:24px 22px }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
